import { callerCreator } from "../callerCreator";
import { singleSlice } from "./singleSlice";

export default callerCreator(singleSlice.actions);
